import { useSettingsStore } from "~/stores/settings";

/**
 * Single-zone shops name their only zone "T" (see settings.ts computeTable),
 * so their table aliases look like "T1", "T5", "T12". On some kitchen printers
 * the font renders the leading "T" almost identically to the digit "1", which
 * makes the slip hard to read. When — and ONLY when — the shop has exactly one
 * zone and it is zone "T", expand such an alias to a spelled-out "Table <n>" so
 * the kitchen can read it unambiguously.
 *
 * Every other configuration is left untouched:
 *  - multi-zone shops (A/B/C…),
 *  - single zones that aren't named "T",
 *  - queue / togo / delivery nickNames ("Queue #3"),
 *  - anything that isn't the "T<number>" shape.
 */
export function formatKitchenTableAlias(alias: string): string {
  if (typeof alias !== "string") return alias;

  const zones = useSettingsStore().tables || [];
  const isSingleZoneT = zones.length === 1 && zones[0]?.name === "T";
  if (!isSingleZoneT) return alias;

  const match = alias.match(/^T(\d+)$/);
  return match ? `Table ${match[1]}` : alias;
}
